import { useState } from "react";

/**
 * Состояние «идёт генерация» для AI-подписок.
 *
 * `loading` у `useSubscription` гаснет на первом сообщении стрима, а первым
 * приходит служебное (смена стадии, вызов инструмента) — задолго до текста.
 * Поэтому генерация считается идущей от запуска и до закрытия стрима
 * (`onComplete`/`onError`).
 */
export function useAiGenerationState() {
  const [generating, setGenerating] = useState(false);

  return {
    generating,
    start: () => setGenerating(true),
    finish: () => setGenerating(false),
  };
}
